import React from 'react';
import { Dialog, DialogPanel, DialogBackdrop, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function FullScreenModal({ isOpen, onClose, title, children, loading = false }) {
  return (
    <Dialog open={isOpen} onClose={() => {}} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-900/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center sm:p-4">
          <DialogPanel
            transition
            className="relative w-full h-dvh sm:h-auto sm:max-h-[90vh] sm:max-w-3xl sm:rounded-lg bg-gray-800 shadow-xl outline -outline-offset-1 outline-white/10 transition-all data-[closed]:opacity-0 data-[closed]:scale-95 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in flex flex-col"
          >
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-700">
              <DialogTitle as="h2" className="text-lg font-semibold text-white">
                {title}
              </DialogTitle>
              <button
                type="button"
                onClick={onClose}
                disabled={loading}
                className="rounded-md text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <span className="sr-only">Close</span>
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>

            <div className="relative flex-1 overflow-y-auto p-6">
              {children}
              {loading && (
                <div className="absolute inset-0 bg-gray-800/50 z-10" />
              )}
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
